import React, { useEffect, useRef } from "react";
import {
  AutoResizeTextArea,
  CheckBoxInput,
  FormContainer,
  FormGroupLabel,
  FormItem,
  Label,
} from "../../shared/components/form/FormElements";
import { Col, Container, Row } from "react-bootstrap";
import FormHeader from "../../shared/components/form/FormHeader";
import { Card, CardBody } from "@/shared/components/Card";
import FormField from "../../shared/components/form/FormField";
import Error from "@/shared/components/form/Error";
import { useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import { formInputStyles, formStyles } from "../../shared/constants/styles";
import { Desc } from "../Reminders/MaintenanceReminders/MaintenanceRemindersForm";
import { postApi } from "../../api/getUser";
import { useDispatch } from "react-redux";
import { addMsg } from "../../features/snackbar/snackbarSlice";
import { useSelector } from "react-redux";
import { fetchExpenseTasks } from "../../features/expenseTasks/expenseTasksSlice";
import ErrorPopup from "../../shared/components/ErrorPopup";
import useAutosizeTextArea from "../../shared/custom-hooks/useAutosizeTextArea";
import AssetDropdown from "../../shared/components/AssetDropdown";

const ExpenseTaskForm = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation("common");
  const {
    handleSubmit,
    reset,
    register,
    control,
    watch,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const { userId } = useSelector((state) => state.user);

  const type = location?.state?.type;
  const rowData = location?.state?.rowData;
  const vehiclesList = useSelector((state) => state.vehicles.list);
  const vehicles = useMemo(() => vehiclesList.filter((v) => v.veh_active === 1 && v.asset_type === 0), [vehiclesList]);
  const expenseTaskOptions = useSelector((state) => state.expenseTasks.list);
  //const allVehicles = useSelector((state) => state.vehicles.list);

  //Coming from Add expense
  const mode = location?.state?.mode;
  const route = location?.state?.route;
  const redirect = location?.state?.redirect;
  const data = location?.state?.data;
  const routeData = location?.state?.routeData;
  //const expenseData = location?.state?.data?.expenseData;

  const [recurringTask, setRecurringTask] = useState(false);
  const [applyToAllVeh, setApplyToAllVeh] = useState(true);

  const [saveBtnLoading, setSaveBtnLoading] = useState(false);

  const expenseTaskName = watch("expenseTaskName");
  const vehicle = watch("vehicle");
  const comments = watch("comments");

  
 const textAreaRef = useRef(null);
 useAutosizeTextArea(textAreaRef.current, comments);

  //To toggle error popup while adding/editing form
  const [showErrPopup, setShowErrPopup] = useState(false);

  //Effect for populating Edit Data
  useEffect(() => {
    if (type === "edit" && vehicles.length > 0) {
      const { expense_task_name, comments, recurring, veh_id } = rowData;
      setValue("expenseTaskName", expense_task_name);
      setValue("comments", comments);
      setRecurringTask(recurring);
      setApplyToAllVeh(veh_id === "All");

      if (veh_id !== "All") {
        setValue(
          "vehicle",
          vehicles.find((v) => v.veh_id === veh_id)
        );
      }
    }

    if (redirect) {
      setValue("expenseTaskName", routeData?.expenseTaskName);
    }
  }, [vehicles]);

  const onSubmit = async () => {
    try {
      if (type !== "edit") {
        for (let expenseTask of expenseTaskOptions) {
          if (applyToAllVeh) {
            if (
              expenseTask.expense_task_name.toLocaleLowerCase() ===
              expenseTaskName.trim().toLocaleLowerCase()
            ) {
              setError(
                "expenseTaskName",
                {
                  type: "custom",
                  message: t("dup_expense_task_name_error"),
                },
                { shouldFocus: true }
              );
              return;
            }
          } else {
            if (
              expenseTask.expense_task_name.toLocaleLowerCase() ===
                expenseTaskName.trim().toLocaleLowerCase() &&
              (expenseTask.veh_id === vehicle.veh_id ||
                expenseTask.veh_id === "All")
            ) {
              setError(
                "expenseTaskName",
                {
                  type: "custom",
                  message: t("dup_expense_task_name_error"),
                },
                { shouldFocus: true }
              );
              return;
            }
          }
        }
      }
      const expenseTaskId =
        type === "edit" ? rowData?.expense_task_id : `${userId}_${Date.now()}`;

      const snackbarMsg =
        type === "edit"
          ? t("record_edited_msg", { recordName: t("expense_task") })
          : t("record_added_msg", { recordName: t("expense_task") });

      const apiData = {
        querystring:
          type === "edit" ? "update_expensetask" : "add_expense_task",
        expense_task_id: expenseTaskId,
        expense_task_name: expenseTaskName,
        recurring: recurringTask ? 1 : 0,
        expensetask_veh_id: applyToAllVeh ? "All" : vehicle.veh_id,
        comments: comments,
        source: "web",
        sync_version: "v2",
        action: type === "edit" ? 2 : 1,
      };

      setSaveBtnLoading(true);
      const response = await postApi(apiData, "commonNew");
      if (response.success === 1) {
        setSaveBtnLoading(false);
        const apiData = {
          querystring: "getallexpensetask",
          expense_veh_id: "All",
        };
        dispatch(fetchExpenseTasks(apiData));

        if (redirect) {
          history.push(route, {
            mode: "from-add-expense-task",
            routeData: { expenseTaskId },
          });
        } else {
          dispatch(addMsg(snackbarMsg));
          history.push("/expenses/expensetasks", { fromCancel: false });
        }
      } else {
        setSaveBtnLoading(false);
        setShowErrPopup(true);
        return;
      }
    } catch (e) {
      console.log(e);
      setSaveBtnLoading(false);
      setShowErrPopup(true);
      return;
    }
  };

  return (
    <>
      {showErrPopup && (
        <ErrorPopup showPopup={showErrPopup} setShowPopup={setShowErrPopup} />
      )}
      <FormContainer onSubmit={handleSubmit(onSubmit)}>
        <FormHeader
          //title={t("add_expense")}
          handleCancel={() =>
            history.push("/expenses/expensetasks", { fromCancel: true })
          }
          //disableSave={!vehicle}
          isSaveLoading={saveBtnLoading}
          title={
            type === "edit" ? t("edit_expense_task") : t("add_expense_task")
          }
          //handleCancel={handleCancel}
        />
        <Container>
          <Card>
            <CardBody
              style={{
                height: `${window.innerHeight - 150}px`,
                overflow: "auto",
              }}
            >
              <Row>
                <Col md={6}>
                  <FormGroupLabel>{t("expense_task_name")}</FormGroupLabel>
                  <FormItem disabled={false}>
                    <FormField
                      name="expenseTaskName"
                      control={control}
                      component="input"
                      defaultValue=""
                      placeholder={t("expense_task_name")}
                      style={formInputStyles}
                      disabled={false}
                      rules={{ required: t("required_err") }}
                    />
                  </FormItem>

                  {errors?.expenseTaskName && (
                    <Error error={errors.expenseTaskName.message} />
                  )}
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroupLabel>{t("notes_tv")}</FormGroupLabel>
                  {/* <FormItem disabled={false}>
                    <FormField
                      name="comments"
                      control={control}
                      component="input"
                      defaultValue=""
                      placeholder={t("notes_tv")}
                      style={formInputStyles}
                      disabled={false}
                    />
                  </FormItem> */}

                  <Controller
                    name="comments"
                    control={control}
                    //defaultValue={users?.length > 0 ? users[0] : ""}
                    //errors={errors}
                    render={({ field: { onChange, value, ref } }) => (
                      <AutoResizeTextArea
                        ref={textAreaRef}
                        onChange={onChange}
                        value={value}
                        placeholder={t("notes_tv")}
                        rows={1}
                        //isDisabled={status == 1 || status == 2}
                      />
                    )}
                    //rules={{ required: t("required_err") }}
                  />

                  {errors?.comments && (
                    <Error error={errors.comments.message} />
                  )}
                </Col>
              </Row>
              <Row className="pt-3">
                <Col md={12}>
                  <CheckBoxInput
                    type="checkbox"
                    id="recurringTask"
                    name="recurringTask"
                    value="recurringTask"
                    checked={recurringTask}
                    onChange={() => setRecurringTask((prev) => !prev)}
                    style={{ margin: "0 8px 0 0" }}
                  />
                  <Label htmlFor="recurringTask">{t("recurring_task")}</Label>
                </Col>
                <Desc style={{ paddingLeft: "2rem" }}>
                  {t("no_reminder_for_nonrecurring_expense")}
                </Desc>
              </Row>
              <Row className="pt-3">
                <Col md={2} className="pt-2">
                  <CheckBoxInput
                    type="checkbox"
                    id="applyToAllVeh"
                    name="applyToAllVeh"
                    value="applyToAllVeh"
                    checked={applyToAllVeh}
                    onChange={() => setApplyToAllVeh((prev) => !prev)}
                    style={{ margin: "0 8px 0 0" }}
                  />
                  <Label htmlFor="applyToAllVeh">{t("apply_all_vehs")}</Label>
                </Col>
                {!applyToAllVeh && (
                  <Col md={4}>
                    {/* <FormGroupLabel className="m-0">{t("vehicle")}</FormGroupLabel> */}
                    <Controller
                      name="vehicle"
                      control={control}
                      //errors={errors}
                      render={({ field: { onChange, value, ref } }) => (
                        // <Select
                        //   options={vehicles}
                        //   value={value}
                        //   onChange={onChange}
                        //   //onCreateOption={handleCreate}
                        //   placeholder={t("vehicle_placeholder")}
                        //   styles={formStyles}
                        //   isDisabled={false}
                        // />
                        <AssetDropdown
                          vehicle={value}
                          onChange={onChange}
                          assets={vehicles}
                          isEquipmentSupported={false}
                          isForm={true}
                        />
                      )}
                      rules={{ required: t("required_err") }}
                    />

                    {errors?.vehicle && (
                      <Error error={errors.vehicle.message} />
                    )}
                  </Col>
                )}
              </Row>
            </CardBody>
          </Card>
        </Container>
      </FormContainer>
    </>
  );
};

export default ExpenseTaskForm;
